// Users' `birthday` column is freeform text with no year, e.g. "July 28" or
// "Dec 9" — some full month names, some abbreviated. This parses that loosely
// rather than assuming a strict date format, since it's hand-typed per row.
// The day-math itself (next occurrence, formatting) lives in
// utils/annualDates.js, shared with work anniversaries.

const MONTHS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

// Returns { month (0-11), day } or null if the text doesn't look like a birthday.
export function parseBirthday(raw) {
  if (!raw) return null;
  const m = String(raw).trim().match(/^([A-Za-z]+)\.?\s+(\d{1,2})/);
  if (!m) return null;
  const month = MONTHS.indexOf(m[1].slice(0, 3).toLowerCase());
  if (month === -1) return null;
  const day = parseInt(m[2], 10);
  if (day < 1 || day > 31) return null;
  return { month, day };
}
